import { faChartSimple, faCopy, faPen, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { ActionsDropdownOption } from 'components/common/ActionsDropdown/ActionsDropdownOption';
import { StatusPillTone } from '../UI/StatusPill/StatusPill';
import { CampaignStatus, EmailCampaign } from '../types';

export const CAMPAIGN_STATUS_TONES: Record<CampaignStatus, StatusPillTone> = {
    draft: 'neutral',
    sending: 'progress',
    sent: 'success',
    failed: 'error'
};

interface CampaignActionHandlers {
    onOpen: (campaign: EmailCampaign) => void;
    onDuplicate: (campaign: EmailCampaign) => void;
    onDelete: (campaign: EmailCampaign) => void;
}

// Row actions per status: only drafts can be edited or deleted (the API rejects it otherwise);
// sent campaigns expose the report.
export const buildCampaignActions = (
    campaign: EmailCampaign,
    { onOpen, onDuplicate, onDelete }: CampaignActionHandlers
): Array<ActionsDropdownOption> => {
    const edit = { id: 'edit', label: 'Edit', icon: faPen, onClick: () => onOpen(campaign) };
    const report = { id: 'report', label: 'View report', icon: faChartSimple, onClick: () => onOpen(campaign) };
    const duplicate = { id: 'duplicate', label: 'Duplicate', icon: faCopy, onClick: () => onDuplicate(campaign) };
    const remove = { id: 'delete', label: 'Delete', icon: faTrashCan, onClick: () => onDelete(campaign) };

    switch (campaign.status) {
        case 'draft':
            return [edit, duplicate, remove];
        case 'sent':
        case 'sending':
            return [report, duplicate];
        case 'failed':
            return [duplicate];
        default:
            return [duplicate];
    }
};
